export const tiktokText = {
  en: {
    subtitle: "Career Videos",
    title: "Follow My Journey",
    highlight: "on TikTok",

    desc: "Watch short career tips, immigrant stories, workplace insights, and practical advice to help you build a fulfilling career in New Zealand.",

    cta: "Follow on TikTok",

    footer: "Discover more career videos & inspiration",

    pageName: "@trambuituvanhuongnghiep",

    pageLabel: "Official TikTok Channel",
  },

  vi: {
    subtitle: "Video Hướng Nghiệp",
    title: "Theo Dõi Hành Trình",
    highlight: "trên TikTok",

    desc: "Xem các video ngắn về định hướng nghề nghiệp, câu chuyện người nhập cư, kinh nghiệm làm việc tại New Zealand và những chia sẻ thực tế giúp bạn phát triển sự nghiệp.",

    cta: "Theo Dõi TikTok",

    footer: "Khám phá thêm nhiều video hướng nghiệp & truyền cảm hứng",

    pageName: "@trambuituvanhuongnghiep",

    pageLabel: "Kênh TikTok chính thức",
  },
};
